<template>
  <div class="newsApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="commen">
      <h2>
        <div class="ctitle">News Center</div>
      </h2>
      <ul class="news">
        <li v-for="(item,i) in setNewsIndex">
          <a @click="$router.push('ndetail?id='+item.id)">
            <p class="showPic">
              <img :src="baseUrl+item.image" style="max-width: 100%;">
            </p> 
            <div class="lesson">
              <p class="camp">{{item.title}}</p>
              <p class="money">{{item.createtime}}</p>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getNewsIndex();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getNewsIndex:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/news',
          dataType:'json',
          success:function(data){
            that.setNewsIndex = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .newsApp .el-message-box{
    width:30%
  }
  .newsApp{
    max-width:750px;
    margin:0 auto;
  }

  .newsApp .commen{
    background:#fff;
    width:100%;
  }
  .newsApp .commen h2{
    margin:0 auto;
    font-size:16px;
    padding:15px 0;
    border-bottom:solid 1px #f5f5f5;
  }
  .newsApp .commen h2 .ctitle{
    width:92%;
    margin:0 auto;
    position:relative;
  }
  .newsApp .commen h2 a{
    float:right;
    font-size:14px;
    font-weight:normal;
    color:#666;
    margin-top:2px
  }
  .newsApp .commen .news {
    width: 96%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;
    padding-bottom:12px
  }
  .newsApp .commen .news li{
    width:48.5%;
    background-color: #fff;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
    margin-top:12px;
    border-radius: 6px;
  }
  .newsApp .commen .news li a{
    display:block;
    width:100%;
    text-decoration: none;
  }
  .newsApp .commen .news li a img{
    border-radius: 6px 6px 0 0;
  }
  .newsApp .commen .news li a .camp{
    width:92%;
    margin:0 auto;
    font-size:15px;
    font-weight: bold;
    color:#333333;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .newsApp .commen .news li a .money{
    width:92%;
    margin:0 auto;
    font-size:14px;
    color:#666;
    padding:8px 0
  }

</style>